import { AnimatePresence } from 'framer-motion';
import { useAssociateFeedbackContext } from '../../contexts/AssociateFeedbackProvider';
import { AssociateFeedback } from '../../types/feedbacks';
import FeedbackDetailsModal from '../CommonComps/Modals/FeedbackDetailsModal';

const AssociateFeedbackModalSection = () => {
  // integration of context hooks here
  const {
    associateFeedback,
    showAssociateFeedbackModal,
    setShowAssociateFeedbackModal,
  } = useAssociateFeedbackContext();

  // rendering associate feedback modal section here
  return (
    <section>
      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showAssociateFeedbackModal && (
          <FeedbackDetailsModal
            feedback={associateFeedback as AssociateFeedback}
            handleModalClose={() => setShowAssociateFeedbackModal(false)}
          />
        )}
      </AnimatePresence>
    </section>
  );
};

export default AssociateFeedbackModalSection;
